module.exports = __webpack_public_path__ + "img/icon_solicitud_consulta_compra_servicio_hover.76772cf8.svg";